import { render, staticRenderFns } from "./Service_history.vue?vue&type=template&id=544f4f0b"
import script from "./Service_history.vue?vue&type=script&lang=js"
export * from "./Service_history.vue?vue&type=script&lang=js"
import style0 from "./Service_history.vue?vue&type=style&index=0&id=544f4f0b&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports